export default __webpack_public_path__ + "static/flowers-red-7cb4a49310028918a26a63dfd147d0b4.png";